import { StatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

const Statuses = {
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    INACTIVE: 'INACTIVE',
    PEND_START: 'PEND_START',
};

function getStatus(status) {
    switch (status) {
        case Statuses.ACTIVE:
            return StatusIndicator.Status.SUCCESS;
        case Statuses.EXPIRED:
            return StatusIndicator.Status.CAUTION;
        case Statuses.PEND_START:
            return StatusIndicator.Status.IN_PROGRESS;
        default:
            return StatusIndicator.Status.DEFAULT;
    }
}

const StatusMessages = {
    [Statuses.ACTIVE]: 'Active',
    [Statuses.EXPIRED]: 'Expired',
    [Statuses.INACTIVE]: 'Inactive',
    [Statuses.PEND_START]: 'Pend. Start',
};

export const ProgramRuleStatusIndicator = ({ status }) => (
    <StatusIndicator
        status={getStatus(status)}
        message={StatusMessages[status]}
        className="font-semi-bold--uppercase"
    />
);

ProgramRuleStatusIndicator.propTypes = {
    status: PropTypes.oneOf(Object.values(Statuses)).isRequired,
};

ProgramRuleStatusIndicator.Statuses = Statuses;
ProgramRuleStatusIndicator.StatusMessages = StatusMessages;
